import { render, staticRenderFns } from "./ViewItemsModal.vue?vue&type=template&id=6677319b&"
import script from "./ViewItemsModal.vue?vue&type=script&lang=js&"
export * from "./ViewItemsModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewItemsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports